import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Components
import ScrollToTop from './components/ScrollToTop';
import VersionChecker from './components/VersionChecker';

// Layout components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import FloatingElements from './components/layout/FloatingElements';

// Pages
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ServicesPageV2 from './pages/ServicesPageV2';
import PricingPage from './pages/PricingPage';
import BookingPage from './pages/BookingPage';
import WasteBookingPage from './pages/WasteBookingPage';
import DeliveryBookingPage from './pages/DeliveryBookingPage';
import SubscriptionsPage from './pages/SubscriptionsPage';
import ServiceAreaPage from './pages/ServiceAreaPage';
import FAQsPage from './pages/FAQsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ThankYouPage from './pages/ThankYouPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import BookingSuccess from './pages/BookingSuccess';
import QuotePage from './pages/QuotePage';
import ClientPortal from './pages/ClientPortal';
import SubscriptionSignupPage from './pages/SubscriptionSignupPage';

// Driver Portal (Transa GO)
import {
  DriverLogin,
  DriverLayout,
  DriverDashboard,
  DriverJobs,
  DriverAvailability,
  DriverDocuments
} from './pages/driver';

// Admin Pages
import { 
  AdminLogin, 
  AdminLayout, 
  AdminDashboard, 
  AdminBookings, 
  AdminPricing,
  AdminClients,
  AdminLeads,
  AdminAnalytics,
  AdminNotes,
  AdminDrivers,
  AdminSMSTemplates,
  MapDispatch
} from './pages/admin';

// Analytics
import Analytics from './components/Analytics';

// Layout wrapper for public pages
const PublicLayout = ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
    <FloatingElements />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Analytics />
        <VersionChecker />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
          <Route path="/services" element={<PublicLayout><ServicesPageV2 /></PublicLayout>} />
          <Route path="/services-old" element={<PublicLayout><ServicesPage /></PublicLayout>} />
          <Route path="/pricing" element={<PublicLayout><PricingPage /></PublicLayout>} />
          <Route path="/book" element={<PublicLayout><BookingPage /></PublicLayout>} />
          <Route path="/book/waste" element={<PublicLayout><WasteBookingPage /></PublicLayout>} />
          <Route path="/book/delivery" element={<PublicLayout><DeliveryBookingPage /></PublicLayout>} />
          <Route path="/booking/success" element={<PublicLayout><BookingSuccess /></PublicLayout>} />
          <Route path="/quote/:token" element={<PublicLayout><QuotePage /></PublicLayout>} />
          <Route path="/subscriptions" element={<PublicLayout><SubscriptionsPage /></PublicLayout>} />
          <Route path="/subscribe" element={<PublicLayout><SubscriptionSignupPage /></PublicLayout>} />
          <Route path="/service-area" element={<PublicLayout><ServiceAreaPage /></PublicLayout>} />
          <Route path="/faqs" element={<PublicLayout><FAQsPage /></PublicLayout>} />
          <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
          <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />
          <Route path="/thank-you/:type" element={<PublicLayout><ThankYouPage /></PublicLayout>} />
          <Route path="/terms" element={<PublicLayout><TermsPage /></PublicLayout>} />
          <Route path="/privacy" element={<PublicLayout><PrivacyPage /></PublicLayout>} />

          {/* Client Portal */}
          <Route path="/manage" element={<ClientPortal />} />

          {/* Transa GO - Driver Portal */}
          <Route path="/go" element={<DriverLogin />} />
          <Route path="/go" element={<DriverLayout />}>
            <Route path="dashboard" element={<DriverDashboard />} />
            <Route path="jobs" element={<DriverJobs />} />
            <Route path="availability" element={<DriverAvailability />} />
            <Route path="documents" element={<DriverDocuments />} />
          </Route>

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="bookings" element={<AdminBookings />} />
            <Route path="map-dispatch" element={<MapDispatch />} />
            <Route path="leads" element={<AdminLeads />} />
            <Route path="clients" element={<AdminClients />} />
            <Route path="subscription-clients" element={<Navigate to="/admin/clients" replace />} />
            <Route path="pricing" element={<AdminPricing />} />
            <Route path="analytics" element={<AdminAnalytics />} />
            <Route path="drivers" element={<AdminDrivers />} />
            <Route path="notes" element={<AdminNotes />} />
            <Route path="sms-templates" element={<AdminSMSTemplates />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
